"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// utility button to inject in forms that is not visible and reachable. forms can then be submitted via the enter key
// Pure Functional component using an ES2015 (ES6) arrow function (only through props, no lifecycle)
// http://stackoverflow.com/questions/477691/submitting-a-form-by-pressing-enter-without-a-submit-button
var FormSubmitOnEnter = function FormSubmitOnEnter(props) {
    return React.createElement("input", { type: "submit", style: { position: "absolute", left: -9999, width: 1, height: 1 }, tabIndex: -1 });
};
exports.default = FormSubmitOnEnter;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FormSubmitOnEnter.tsx
 ** module id = 1303
 ** module chunks = 0
 **/